/** Sheets (Univer Workspace embed at /sheets) — Plan 1966 */
export const sheetsTranslations = {
  navName: "Sheets",
  iframeTitle: "Zaviago Sheets",
  loading: "Opening Sheets…",
  errorTitle: "Couldn't open Sheets",
  errorBody: "Something went wrong while signing you in. Please try again.",
  errorMissingIdentity: "We couldn't find your store or account details. Please sign in again.",
  retry: "Try again",
  notEnabledTitle: "Sheets isn't turned on for your store yet",
  notEnabledBody: "Sheets lets your team create spreadsheets, docs and slides together. Contact Zaviago to turn it on.",
  noAccessTitle: "You don't have access to Sheets",
  noAccessBody: "Your account or store can't use Sheets right now. Ask your store owner or contact Zaviago.",
  contactSupport: "Go to Help Center",
} as const;
